<template>
  <div class="mb-4">
    <!--#region breadcrumb to illustrate ftie steps-->
    <template>
      <b-breadcrumb :items="breadcrumbItems" style="font-size:14px"></b-breadcrumb>
    </template>
    <!--#endregion breadcrumb-->
    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4" v-if="basicInfo !== null">
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
        <b-badge style="margin-left: 13.5px;"
                 v-if="basicInfo.ticket_type === 'ETO Sector SKU'"
                 variant="primary">
        ETO Sector SKU</b-badge>
      </div>
      <div class="row mb-4" v-if="basicInfo !== null">
        <div class="col-3">
          <div class="header-col">
            <div>FTIE ID</div>
            <div>{{ basicInfo.ftie_id }}</div>
          </div>
          <div class="header-col">
            <div>Device</div>
            <div>{{ basicInfo.device }}</div>
          </div>
          <div class="header-col">
            <div>Vertical</div>
            <div>{{ basicInfo.vertical }}</div>
          </div>
        </div>
        <div class="col-4">
          <div class="header-col">
            <div>Salesforce Opportunity</div>
            <div>{{ basicInfo.opty_name  }}</div>
          </div>
          <div class="header-col">
            <div>Account Name</div>
            <div>{{basicInfo.account }} </div>
          </div>
        </div>
        <div class="col-5">
          <div class="header-col">
            <div>Issue/Requirement Description</div>
            <div>
              <gtc-froala :read-only="true"
                          v-model="basicInfo.issue_desc" class="bg-white" />

            </div>
          </div>
          <div class="header-col">
            <div>Escalation Description</div>
            <div>
              <gtc-froala :read-only="true"
                          v-model="basicInfo.escalation_desc" class="bg-white" />
            </div>
          </div>
        </div>
      </div>
      <!--#endregion Header-->
    </div>
    <!--#endregion-->

    <div style="margin-bottom: 6rem;">
      <!--#region NRE Creation and Standard SKUs/PNs for Reference-->
      <div class="stage-body-rsm-comments-and-conclusions border-bottom pb-4 mb-4">
        <div class="caption-label d-flex">
          <div>NRE Creation and Standard SKUs/PNs for Reference</div>
          <div v-if="actionEnable" class="ml-3 mb-1 d-print-none">
            <button type="button"
                    class="btn btn-primary btn-sm min-w-4"
                    @click="showRefSkuItemModal">
              Add
            </button>
          </div>
        </div>

        <div style="padding-top: 10px;">
          <b-table :fields="skuPnListForNreFields" :items="skuPnListForNre"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searchingStdSku"
                   style="width: calc(100% - 10px)">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <!-- ETO PreCheck Icon -->
            <!--
                <template #cell(standard_sku_id)="data">
                  <div>
                    <div class="row mb-2">
                      <div v-if="data.item.nre_quotes != null" class="col-4">
                        <div style="margin-left: 1.1rem;">{{data.item.standard_sku_id}}</div>
                      </div>
                      <div v-else class="col-4">
                        <div style="margin-left: 1.1rem;">-</div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div style="padding-left: 30px;">
                        <span style="
                                  display: inline-flex;
                                  font-family: 'Arial Black', 'Helvetica Neue', sans-serif;
                                  color: #005288;
                                  text-transform: uppercase;
                                  font-size: 11px;
                                  font-weight: 900;
                                  letter-spacing: -0.5px;
                                  line-height: 1;
                                  gap: 1px;
                                ">
                          <span>ETO</span>
                          <span style="font-size: 9px; font-weight: 700; align-self: flex-end; padding-bottom: 6px;">Pre</span>
                          <span style="
                                width: 11px;
                                height: 11px;
                                background-color: #89d94c;
                                border-radius: 2px;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                position: relative;
                                transform: translateY(1px);
                                flex-shrink: 0;
                              ">
                            <span style="
                              display: block;
                              width: 3px;
                              height: 5px;
                              border: solid white;
                              border-width: 0 2px 2px 0;
                              transform: rotate(45deg);
                              margin-top: -2px;
                            "></span>
                          </span>
                          <sup style="font-size: 7px; font-weight: 700; margin-left: 1px;">®</sup>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
  -->
            <!-- NRE QUOTES Region .nre_quotes -->
            <template #cell(nre_quotes)="data">
              <div>
                <div class="row mb-2">
                  <div v-if="data.item.nre_quotes != null" class="col-4">
                    <div style="margin-left: 1.1rem;">{{_.size(data.item.nre_quotes)}}</div>
                  </div>
                  <div v-else class="col-4">
                    <div style="margin-left: 1.1rem;">-</div>
                  </div>
                  <div class="col-6">
                    <div v-if="actionEnable">
                      <button type="button"
                              class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                              @click="showNreQuoationModal(data.item)"></button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- #region -- Add/Edit NRE Quotation. Modal-->
              <b-modal hide-footer
                       centered size="lg"
                       v-if="data.item.nre_quotes !== null"
                       ref="nreQuotationModal"
                       title="Add NRE Quotation"
                       button-size="sm">
                <div class="header-col">
                  <div><b>Certified Models</b></div>
                  <div v-if="basicInfo !== null && basicInfo.device !== null">{{basicInfo.device}}</div>
                </div>
                <div class="header-col">
                  <div><b>Product Family</b></div>
                  <div v-if="quotedNreInModal !== null && quotedNreInModal.itemObj !== null">{{quotedNreInModal.itemObj.product_family}}</div>
                </div>


                <div class="header-col">
                  <div><b>Real SKU NO</b></div>
                  <div v-if="quotedNreInModal !== null
                       && quotedNreInModal.itemObj !== null">{{quotedNreInModal.itemObj.real_sku_no}}</div>
                </div>

                <div class="header-col">
                  <div><b>Ref.(Standard) SKU ID</b></div>
                  <div v-if="quotedNreInModal !== null
                       && quotedNreInModal.itemObj !== null">{{quotedNreInModal.itemObj.standard_sku_id}}</div>
                </div>

                <div class="header-col">
                  <div><b>Customization SKU ID</b></div>
                  <div v-if="quotedNreInModal !== null
                       && quotedNreInModal.itemObj !== null">{{quotedNreInModal.itemObj.custom_sku_id}}</div>
                </div>

                <div class="border-bottom" style="padding-top: 1rem;"></div>
                <div style="padding-top: 1rem;">
                  <div class="ml-3 mb-1 d-print-none">
                    <button type="button"
                            class="btn btn-primary btn-sm min-w-4"
                            @click="showAddNewNreModal(quotedNreInModal, 'add', null)">
                      Add New NRE
                    </button>
                    <span>Or copy from the existing one.</span>
                  </div>
                </div>

                <div style="padding-top: 10px;"
                     v-if="refSkuList !== null
                     && quotedNreInModal !== null
                     && quotedNreInModal.itemObj !== null">
                  <b-table :fields="quotedNreFields" :items="quotedNreInModal.itemObj.nre_quotes"
                           small
                           thead-class="thead-light text-dark"
                           :busy="searchingNre"
                           style="width: calc(100% - 10px)">
                    <template #cell(nre_id)="data">
                      <a class="link" target="_blank"
                         :href="safeUrl(`${$root.frontEndUrl}/espm-submitted/${ftieId}/${_.get(addOrCloneNreModalData, 'customizationSkuId', null)}/${data.item.nre_id}/${_.get(addOrCloneNreModalData, 'realSkuNo', null)}/${createBy}`)">

                        <!-- https://localhost:8080/espm-submitted/15993/DSI-040819-090/2779/2007/jimmy.chang -->
                        {{ data.item.nre_id }}
                      </a>
                    </template>
                    <template #cell(action)="data">
                      <button type="button"
                              class="btn btn-primary btn-sm min-w-4"
                              @click="showAddNewNreModal(addOrCloneNreModalData, 'copy', data.item.nre_id)">
                        Copy
                      </button>
                    </template>

                  </b-table>

                </div>


              </b-modal>

              <!-- #endregion-->

            </template>

            <template #cell(customization_pn_set)="data">
              <div v-for="pn_set, index in data.item.ref_pn_set" :key="index">
                <div v-if="pn_set != null">
                  <div class="row mb-2" v-if="pn_set !== null">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                      <!--                       <div>TAA</div>
            -->
                    </div>
                    <div class="col-8">
                      <div>: {{ pn_set.mps_pn }}</div>
                      <div>: {{ pn_set.ship_pn }}</div>
                      <!--                      <div>: {{ pn_set.taa_pn }}</div>
            -->

                    </div>
                  </div>
                </div>
              </div>
              <!-- #region -- Add/Maintain MPS, SHIP, TAA PN in Table 2                         size="sm" -->
              <b-modal centered
                       ok-title="Ok"
                       cancel-title="Cancel"
                       ref="RefSkuErrorModal"
                       title="Error"
                       button-size="sm">
                <div>{{ saveRefSkuError }}</div>
              </b-modal>
            </template>
          </b-table>
        </div>
      </div>
      <!--#endregion NRE Creation and Standard SKUs/PNs for Reference-->
      <!--#region SFDC BY Components -->
      <sfdc-prd-line v-if="sfdcProducts!=null"
                     :prop_sfdc_page_obj="sfdcProducts"
                     :prop_basic_info="basicInfo"
                     :prop_user="loginUser"
                     :prop_user_sites="userSites"
                     :prop_request_detail_id="detailId"/>
      <!--#endregion-->
    </div>

    <!--#endregion-->
    <!-- #region -- Add or Clone NRE Modal -->
    <b-modal centered size="lg"
             style="margin-top: 240px;margin-left: 120px;"
             ok-title="Add"
             @ok="validateNreRemark(addOrCloneNreModalData) && routerNreQuoteAction(addOrCloneNreModalData)"
             ref="addOrCloneNreModal"
             title="Add New NRE Quote"
             button-size="sm">
      <div class="header-col">
        <div class="col-5"><b>Real SKU #</b></div>
        <div v-if="addOrCloneNreModalData !== null && addOrCloneNreModalData.realSkuNo !== null">
          {{addOrCloneNreModalData.realSkuNo}}
        </div>
      </div>
      <div class="header-col">
        <div class="col-5"><b>Reference  SKU ID</b></div>
        <div v-if="addOrCloneNreModalData !== null && addOrCloneNreModalData.standardSkuId !== null">
          {{addOrCloneNreModalData.standardSkuId}}
        </div>
      </div>
      <div class="header-col">
        <div class="col-5"><b>Clone NRE by ID</b><span class="text-info pl-1">(Not Necessary)</span></div>
        <div>
          <gtc-text-box :readOnly="false"
                        placeholder="Enter existing NRE ID"
                        class="form-control form-control-sm" required
                        v-model="addOrCloneNreModalData.cloneNreId" />
        </div>
      </div>
      <div class="header-col">
        <div class="col-5"><b>Remark</b><span class="text-danger pl-1">*</span></div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <textarea class="w-100" v-model="addOrCloneNreModalData.remark"></textarea>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- #endregion: add/clone nre modal-->
    <!-- #region -- Add Ref SKU, Desc. Modal-->
    <b-modal centered size="lg"
             ok-title="Add"
             v-if="refSkuList !== null"
             @ok="saveRefSkuItem"
             ref="addRefSkuModal"
             title="Add Ref SKU for NRE Quotation"
             button-size="sm">
      <div class="header-col">
        <div><b>Certified Model</b></div>
        <div v-if="basicInfo !== null && basicInfo.device !== null">
          {{basicInfo.device}}
          <b-form-checkbox v-model="basicInfo.fix_model"
                           name="check-button"
                           @change="fixModelforSKUs(basicInfo.fix_model)"
                           switch>
            Restrict SKUs for this model:<b>{{ basicInfo.fix_model }}</b>
          </b-form-checkbox>
        </div>
      </div>
      <!--
                <div class="header-col-wider">
          <div><b>Restrict SKUs for this model only</b></div>
          <div v-if="basicInfo !== null && basicInfo.device !== null && basicInfo.fix_model !== null">
            <b-form-checkbox v-model="basicInfo.fix_model"></b-form-checkbox>
          </div>
        </div>

  -->


      <div class="border-bottom" style="padding-top: 1rem;"></div>
      <div style="padding-top: 1rem;">
        <span>Please select reference(standard) SKU to add a NRE quotation.</span>
      </div>


      <div v-if="saveRefSkuError !== null " class="row mb-2">
        <div class="col-12">
          <b class="text-danger pl-1">* {{saveRefSkuError}}</b>
        </div>

      </div>

      <div style="padding-top: 10px;" v-if="refSkuList !== null">
        <b-table :fields="refSkuListFields" :items="refSkuList"
                 small
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)">
          <template #cell(chosen)="data">
            <b-form-checkbox v-model="data.item.chosen"></b-form-checkbox>
          </template>
        </b-table>
      </div>


    </b-modal>
    <!-- #endregion-->
  </div>
  <!-- https://10.68.90.169:9001/ftie/NRE_FLOW/new_set_customer_pn.aspx?ftie_id=15993&detail_id=12188&request_form_id=2213 -->
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    data() {
      return {
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        detailId: encodeURIComponent(this.$route.params.detail_id),
        requestFormId: encodeURIComponent(this.$route.params.request_form_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        actionEnable: false,
        createBy: null,
        breadcrumbItems: [
          {
            text: 'SKU/NRE/PN Maintain',
              active: true
          },
          {
            text: 'Ticket #' + encodeURIComponent(this.$route.params.ftie_id),
          },
          {
            text: 'Request Form #' + encodeURIComponent(this.$route.params.request_form_id),
          },
        ],
        searching: false,
        searchingNre: false,
        searchingStdSku: false,
        basicInfo: null,
        refSkuList: null,
        refSkuListOriginal: null,
        selectedRefSkuIndex: null,
        selectedRefSkuItems: [],
        saveRefSkuError: null,
        skuPnListForNre: null,
        skuPnListForNreFields: [
          { key: 'real_sku_no', label: 'SKU#', thClass: 'align-middle', sortable: true },
          { key: 'custom_sku_id', label: 'Customization SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'standard_sku_id', label: 'Standard SKU ID', thClass: 'align-middle', sortable: true },
          {
            key: 'standard_sku_desc', label: 'SKU Description',
            thClass: 'align-middle', thStyle: { width: "35%" },
            sortable: true
          },
          {
            key: 'product_family', label: 'Product Family',
            thClass: 'align-middle',
            sortable: true
          }, 
          {
            key: 'nre_quotes', label: 'NRE Quote', thClass: 'align-middle',
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.nre_quotes_cnt;
            }
          },
          {
            key: 'customization_pn_set', label: 'Standard P/N Maintain in SFDC', thClass: 'align-middle',
            tdClass: 'min-w-187',
            thStyle: { width: "20%" },
            sortable: true
          },
          {
            key: 'create_date', label: 'Create Date',
            thClass: 'align-middle', thStyle: { width: "10%" },
            sortable: true
          },
        ],
        refSkuListFields: [
          { key: 'chosen', label: '', thClass: 'align-middle', sortable: false },
          { key: 'model_name', label: 'Model', thClass: 'align-middle', sortable: true},//model_name
          { key: 'standard_sku_id', label: 'Reference SKU ID', thClass: 'align-middle', sortable: true },
          {
            key: 'standard_sku_desc', label: 'SKU Description',
            thClass: 'align-middle', thStyle: { width: "65%" },
            sortable: true
          },
        ],
        quotedNreInModal: {
          itemObj: null,
          title: '',
          message1: 'Are you sure want to return?',
          message2: 'Please describe the reason for returning this quotation.',
          invalidFeedback: 'Please describe the reason for returning this NRE quotation!'
        },
        mpsShipTaaPnModal: {
          itemObj: null,
          mpsPn: null,
          customShipPn: null,
          taaPn: null,
          //action: 'return',
          //variant: 'danger',
        },
        quotedNreFields: [
          //{ key: 'chosen', label: '', thClass: 'align-middle', sortable: false },
          { key: 'nre_id', label: 'NRE ID', thClass: 'align-middle', sortable: true },
          {
            key: 'status', label: 'Current Stage/Status',
            thClass: 'align-middle',
            thStyle: { width: "25%" },
            sortable: true
          },
          {
            key: 'create_date', label: 'Create Date', thClass: 'align-middle',
            thStyle: { width: "15%" },
            sortable: true
          },
          {
            key: 'remark', label: 'Remark',
            thClass: 'align-middle',
            thStyle: { width: "45%" },
            sortable: true
          },
          { key: 'action', label: 'Action', thClass: 'align-middle', sortable: false },
        ],
        sfdcProducts: null,
        addOrCloneNreModalData: {
          cloneNreId: '',
          remark: '',
          standardSkuId: '',
          customizationSkuId: '',
          realSkuNo: '',
          action: '',
          errorMsg: '',
          standardSkuDesc: '',
          productFamily: ''
        },
        nreRemarkWarning: null,
      };
    },
    created() {
      let self = this;
      self.getPage(null);
      self.actionEnable = self.checkActionEnable();
      console.log("Customization NRE/PN Page actionEnable:");
      console.log(self.actionEnable);
      //self.getSfdcProduct();
    },
    computed: {
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

      userSites() {
        return this.$session.get('user_site');
      },

      /*
      nrePage: {
        get() {
          return this.$attrs.data;
        },
        set(value) {
          this.$attrs.data = value;
        }
      },
      */
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
        //return 'DEV' !== this.$session.get('mode');
      },
      fixModelforSKUs(fixModel) {
        let self = this;
        console.log("self.refSkuListOriginal =");
        console.log(self.refSkuListOriginal);
        if (fixModel === true
          && _.get(self.basicInfo, 'device') !== null
          && self.refSkuListOriginal !== null && self.refSkuListOriginal.length > 0) {
          let refSkuPolished = _.filter(self.refSkuListOriginal, { 'model_name': _.get(self.basicInfo, 'device') });
          console.log("refSkuPolished = {}");
          console.log(refSkuPolished);
          self.refSkuList = JSON.parse(JSON.stringify(refSkuPolished));
        }
        else {
          self.refSkuList = JSON.parse(JSON.stringify(self.refSkuListOriginal));
        }
      },
      nreEspmPage(nreId, realSkuNo, customSkuId) {
        //https://localhost:8080/espm-submitted/15993/DSI-040819-090/2779/2007/jimmy.chang
        let self = this;
        return `${$root.frontEndUrl}/espm-submitted/${self.ftieId}/${nreId}/${realSkuNo}/${self.createBy}`;
      },
      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },

      resetAddOrCloneNreModalData(excludeSkuVal) {
        let self = this;
        _.set(self.addOrCloneNreModalData, 'cloneNreId', null);
        _.set(self.addOrCloneNreModalData, 'remark', '');
        if (excludeSkuVal === false) {
          // reset all, no need to exclude SKU VAL cleaning
          _.set(self.addOrCloneNreModalData, 'standardSkuId', '');
          _.set(self.addOrCloneNreModalData, 'customizationSkuId', '');
          _.set(self.addOrCloneNreModalData, 'realSkuNo', '');
          _.set(self.addOrCloneNreModalData, 'standardSkuDesc', '');
          _.set(self.addOrCloneNreModalData, 'productFamily', '');
        }
        _.set(self.addOrCloneNreModalData, 'action', null);
        _.set(self.addOrCloneNreModalData, 'errorMsg', null);
      },


      refreshNreQuotes(realSkuNo) {
        let self = this;
        let refSkuPnItem = self.skuPnListForNre[_.findIndex(self.skuPnListForNre, { 'real_sku_no': realSkuNo })];
        let quotedNreitem = _.get(refSkuPnItem, 'nre_quotes', new Array());
        self.quotedNreInModal.itemObj = JSON.parse(JSON.stringify(refSkuPnItem));
        console.log("[refreshNreQuotes] quotedNreitem::");
        console.log(quotedNreitem);

      },

      validateNreRemark(modalItem) {
        let self = this;
        if (_.get(modalItem, 'remark', null) === null || _.trim(_.get(modalItem, 'remark', '')) === '') {
          self.nreRemarkWarning = 'Please input the simple description for this NRE creation.';
          self.$message.warning('Please input the simple description for this NRE creation!', 'Warning');
          return false;
        }
        else {
          if (_.get(modalItem, 'cloneNreId', null) === null || _.trim(_.get(modalItem, 'cloneNreId', '')) === ''){
            self.nreRemarkWarning = null;
            return true;
          }
          else {
            if (_.size(_.trim(_.get(modalItem, 'cloneNreId', ''))) > 6 || (/^\d+$/.test(_.trim(_.get(modalItem, 'cloneNreId', '')))) === false)
            {
              self.nreRemarkWarning = 'Please input the correct NRE ID format.';
              self.$message.warning('Please input the correct NRE ID format for this NRE creation!', 'Warning');
              return false;
            }
            else {
              self.nreRemarkWarning = null;
              return true
            }
          }
        }
      },

      getPage(realSkuForNreRefresh) {
        let self = this;
        self.ftieId = encodeURIComponent(self.$route.params.ftie_id);
        self.detailId = encodeURIComponent(self.$route.params.detail_id);
        self.requestFormId = encodeURIComponent(self.$route.params.request_form_id);

        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          ftie_id: self.ftieId,
          detail_id: self.detailId,
          request_form_id: self.requestFormId,
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/customization-nre-pn/', requestData)
          .then(res => {
            let result = res.data;
            result.basic_info = JSON.parse(result.basic_info);

            if (_.get(result, 'sku_pn_info_list_for_nre', null) !== null &&
              _.size(_.get(result, 'sku_pn_info_list_for_nre', new Array())) > 0) {
              result.sku_pn_info_list_for_nre = JSON.parse(result.sku_pn_info_list_for_nre);
            }

            if (_.get(result, 'ref_sku_info_list', null) !== null &&
              _.size(_.get(result, 'ref_sku_info_list', new Array())) > 0) {
              result.ref_sku_info_list = JSON.parse(result.ref_sku_info_list);
            }

            if (_.get(result, 'sfdc_line_info_list', null) !== null &&
              _.size(_.get(result, 'sfdc_line_info_list', new Array())) > 0){
              result.sfdc_line_info_list = JSON.parse(result.sfdc_line_info_list);
            }

            console.log("result.sku_pn_info_list_for_nre::");
            console.log(result.sku_pn_info_list_for_nre);
            console.log("result.ref_sku_info_list::");
            console.log(result.ref_sku_info_list);
            console.log("result.basic_info::");
            console.log(result.basic_info);
            console.log("result.sfdc_line_info_list::");
            console.log(result.sfdc_line_info_list);

            self.basicInfo = result.basic_info;
            self.createBy = _.get(result.basic_info, 'gtc_owner', null);
            self.refSkuList = result.ref_sku_info_list;
            self.refSkuListOriginal = result.ref_sku_info_list;
            self.fixModelforSKUs(true);
            self.sfdcProducts = result.sfdc_line_info_list

            self.skuPnListForNre = result.sku_pn_info_list_for_nre;

          })
          .finally(() => {
            console.log("COMPLETE /nre/customization-nre-pn/");
            if (realSkuForNreRefresh !== null && realSkuForNreRefresh !== '') {
              self.refreshNreQuotes(realSkuForNreRefresh);
            }
            self.searching = false;
            self.resetAddOrCloneNreModalData(true);
            self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
          });

      },

      /* #region: NRE Modal: (1)show quoted nre, (2)add new nre modal*/
      showNreQuoationModal(item) {
        /**item refer to data.item (skuPnListForNre[i]) */
        let self = this;
        self.resetAddOrCloneNreModalData(false); // no need to exclude sku related info, reset all!
        if (item !== null) {
          _.set(self.quotedNreInModal, 'itemObj', JSON.parse(JSON.stringify(item)));
          _.set(self.quotedNreInModal, 'title', 'Add NRE Quotation for SKU#' + item.real_sku_no);

          _.set(self.addOrCloneNreModalData, 'realSkuNo', _.get(item, 'real_sku_no', null));
          _.set(self.addOrCloneNreModalData, 'standardSkuId', _.get(item, 'standard_sku_id', null));
          _.set(self.addOrCloneNreModalData, 'customizationSkuId', _.get(item, 'custom_sku_id', null));
          _.set(self.addOrCloneNreModalData, 'standardSkuDesc', _.get(item, 'standard_sku_desc', null));
          try {
            _.set(self.addOrCloneNreModalData, 'productFamily', _.get(item, 'product_family', null));
          } catch (e) {
            _.set(self.addOrCloneNreModalData, 'productFamily', null);
          }
        }

        self.$refs['nreQuotationModal'].show();
      },
      showAddNewNreModal(item, action, nreIdfromSameTicket) {
        /** both NEW, CLONE and COPY NRE will go through this method before modal show up
         * quotedNreInModal.itemObj.
         */
        let self = this;
        if ('add' === action) {
          if (item !== null && _.get(item, 'itemObj', null) !== null) {
            _.set(self.addOrCloneNreModalData, 'realSkuNo', _.get(item.itemObj, 'real_sku_no', null));
            _.set(self.addOrCloneNreModalData, 'standardSkuId', _.get(item.itemObj, 'standard_sku_id', null));
            _.set(self.addOrCloneNreModalData, 'customizationSkuId', _.get(item.itemObj, 'custom_sku_id', null));
            _.set(self.addOrCloneNreModalData, 'standardSkuDesc', _.get(item.itemObj, 'standard_sku_desc', null));
            _.set(self.addOrCloneNreModalData, 'action', action);
            _.set(self.addOrCloneNreModalData, 'cloneNreId', null);
            try {
              _.set(self.addOrCloneNreModalData, 'productFamily', _.get(item.itemObj, 'product_family', null));
            } catch (e) {
              _.set(self.addOrCloneNreModalData, 'productFamily', null);
            }
             
          }
        } else {
          if (self.addOrCloneNreModalData !== null && 'copy' === action && nreIdfromSameTicket !== null) {
            _.set(self.addOrCloneNreModalData, 'cloneNreId', nreIdfromSameTicket);
            _.set(self.addOrCloneNreModalData, 'action', action);
          }
        }
        self.$refs['addOrCloneNreModal'].show();
      },

      routerNreQuoteAction(modalData) {
        console.log("routerNreQuoteAction");
        let self = this;
        if (_.get(modalData, 'action', null) === 'copy' && _.get(modalData, 'cloneNreId', null) !== null) {
          console.log("redirect to copyNreQuoteFromSameTicket method!");
          self.copyNreQuoteFromSameTicket(modalData, _.get(modalData, 'cloneNreId', null));
        }
        else if (_.get(modalData, 'action', null) === 'add') {
          console.log("redirect to saveAddNewNreQuote method!");
          self.saveAddNewNreQuote(modalData);
        }
        else {
          return
        }
      },

      copyNreQuoteFromSameTicket(modalData, nreIdfromSameTicket) {
        console.log("copyNreQuoteFromSameTicket by nre_id:" + nreIdfromSameTicket);

        let self = this;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let action = _.trim(nreIdfromSameTicket) === '' ? 'add' : 'copy';
        let realSkuNoForRefresh = _.get(modalData, 'realSkuNo', null);
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          ftie_id: self.ftieId,
          nre_id: _.trim(nreIdfromSameTicket),
          real_sku_no: modalData.realSkuNo,
          remark: modalData.remark,
          account: self.basicInfo.account,
          opty_name: self.basicInfo.opty_name,
          ref_request_form_id: self.requestFormId,
          es_number: self.basicInfo.es_number,
          custom_sku_id: modalData.customizationSkuId,
          standard_sku_id: modalData.standardSkuId,
          action: action,
          standard_sku_desc: modalData.standardSkuDesc,
        };

        let url = self.$root.baseUrl + '/nre/';
        url = url + (action === 'add' ? 'new-nre/' : 'clone-nre/');
        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData, { params })
          .then(res => {

            if (_.get(res, 'data.error_msg', null) !== null && _.get(res, 'data.error_msg', null) !== '') {
              _.set(self.addOrCloneNreModalData, 'errorMsg', _.get(res, 'data.error_msg', null));
            }
            else {
              _.set(self.addOrCloneNreModalData, 'errorMsg', null);
            }

            if (_.get(res, 'data.insert_success', false) &&
              (_.get(self.addOrCloneNreModalData, 'errorMsg', null) === null || _.get(self.addOrCloneNreModalData, 'errorMsg', null) === '')) {
              self.getPage(realSkuNoForRefresh);
            }
            else {
              if (_.get(self.addOrCloneNreModalData, 'errorMsg', null) !== null && _.get(res, 'data.error_msg', null) !== '') {
                self.$message.error(`${requestData.action === 'add' ? 'Insert' : 'Copy'} NRE Failed: ${self.addOrCloneNreModalData.errorMsg}`);
              }
              else {
                self.$message.error(`${requestData.action === 'add' ? 'Insert' : 'Copy'} NRE Failed!`);
              }
            }

          }).finally(() => {
            self.resetAddOrCloneNreModalData(true); // exclude reset SKU related value in addOrCloneNreModalData
            eventHub.$emit('loading', false);
          });
      },

      saveAddNewNreQuote(modalData) {
        console.log("saveAddNewNreQuote");

        let self = this;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let action = _.trim(modalData.cloneNreId) === '' ? 'add' : 'clone';
        let realSkuNoForRefresh = _.get(modalData, 'realSkuNo', null);
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          ftie_id: self.ftieId,
          nre_id: _.trim(modalData.cloneNreId),
          real_sku_no: modalData.realSkuNo,
          remark: modalData.remark,
          account: self.basicInfo.account,
          opty_name: self.basicInfo.opty_name,
          ref_request_form_id: self.requestFormId,
          es_number: self.basicInfo.es_number,
          custom_sku_id: modalData.customizationSkuId,
          standard_sku_id: modalData.standardSkuId,
          action: action,
          standard_sku_desc: modalData.standardSkuDesc,
          product_family: modalData.productFamily
        };

        let url = self.$root.baseUrl + '/nre/';
        url = url + (action === 'add' ? 'new-nre/' : 'clone-nre/');
        eventHub.$emit('loading', true);
        self.$axios
          .post(url, requestData, { params })
          .then(res => {

            if (_.get(res, 'data.error_msg', null) !== null && _.get(res, 'data.error_msg', null) !== '') {
              _.set(self.addOrCloneNreModalData, 'errorMsg', _.get(res, 'data.error_msg', null));
            }
            else {
              _.set(self.addOrCloneNreModalData, 'errorMsg', null);
            }

            if (_.get(res, 'data.insert_success', false) &&
              (_.get(self.addOrCloneNreModalData, 'errorMsg', null) === null || _.get(self.addOrCloneNreModalData, 'errorMsg', null) === '')) {
              self.getPage(realSkuNoForRefresh);
            }
            else {
              if (_.get(self.addOrCloneNreModalData, 'errorMsg', null) !== null && _.get(res, 'data.error_msg', null) !== '') {
                self.$message.error(`${requestData.action === 'add' ? 'Insert' : 'Copy'} NRE Failed: ${self.addOrCloneNreModalData.errorMsg}`);
              }
              else {
                self.$message.error(`${requestData.action === 'add' ? 'Insert' : 'Copy'} NRE Failed!`);
              }

            }
          }).finally(() => {
            self.resetAddOrCloneNreModalData(true);
            eventHub.$emit('loading', false);
          });
      },
      showEditMpsShipTaaPnModal(item) {
        let self = this;
        /*customization_pn_set : [{"mps":"N/A","ship":"N/A","taa":"N/A"}]*/
        if (item !== null && item.customization_pn_set !== null) {
          self.mpsShipTaaPnModal = {
            itemObj: JSON.parse(JSON.stringify(item)),
            realSkuNo: item.real_sku_no,
            refSkuId: item.standard_sku_id,
            customSkuId: item.custom_sku_id,
            mpsPn: item.customization_pn_set[0].mps_pn, //'Mps1111111',
            customShipPn: item.customization_pn_set[0].ship_pn, //'Cus1111111',
            taaPn: item.customization_pn_set[0].taa_pn, //'Taa1111111',
          };
        }
        self.$refs['addMpsShipTaaPnModal'].show();
      },

      showRefSkuItemModal() {
        let self = this;
        self.saveRefSkuError = null;
        self.$refs['addRefSkuModal'].show();
      },

      saveRefSkuItem(bvModalEvt) {
        let self = this;
        let refSkuItemsToAdd = new Array();
        let productFamilyTemp = null;
        for (let i = 0; i <= self.refSkuList.length; i++) {
          if (_.get(self.refSkuList[i], 'chosen', false) === true) {
            try {
              productFamilyTemp = _.get(self.refSkuList[i], 'product_family', '');
            } catch (e) {
              console.log("fail to catch prd family")
            }

            refSkuItemsToAdd.push({
              'chosen': _.get(self.refSkuList[i], 'chosen', true),
              'standard_sku_id': _.get(self.refSkuList[i], 'standard_sku_id', ''),
              'standard_sku_desc': _.get(self.refSkuList[i], 'standard_sku_desc', ''),
              'product_family': productFamilyTemp
            })
          }
        }

        console.log("self.refSkuList");
        console.log(self.refSkuList);
        console.log("!!!refSkuItemsToAdd");
        console.log(refSkuItemsToAdd);
        if (refSkuItemsToAdd.length > 0 ){
          let requestData = {
            create_by: self.createBy,
            username: self.loginUser,
            ftie_id: self.ftieId,
            detail_id: self.detailId,
            standard_sku_id: _.get(refSkuItemsToAdd[0], 'standard_sku_id', ''),
            standard_sku_desc: _.get(refSkuItemsToAdd[0], 'standard_sku_desc', ''),

            product_family: _.get(refSkuItemsToAdd[0], 'product_family', ''),
          };
          //eventHub.$emit('loading', true);
          this.$axios
            .post(self.$root.baseUrl + '/nre/sku-for-nre/create/', requestData)
            .then(res => {
              let result = res.data;
              console.log("result.insert_success::");
              console.log(result.insert_success);
              if (result.error_msg !== null && result.error_msg !== '') {
                self.saveRefSkuError = result.error_msg;
              }
              else {
                self.saveRefSkuError = null;
              }

            })
            .finally(() => {
              if (self.saveRefSkuError !== null && self.saveRefSkuError !== '') {
                self.$refs['RefSkuErrorModal'].show();
              }
              self.getPage(null);

            });
        }
      },
      saveMpsShipTaaPn(bvModalEnt) {
        let self = this;
        if (self.mpsShipTaaPnModal !== null) {
          let requestData = {
            create_by: self.createBy,
            username: self.loginUser,
            ftie_id: self.ftieId,
            detail_id: self.detailId,
            sku_no: self.mpsShipTaaPnModal.realSkuNo,
            ref_sku_id: self.mpsShipTaaPnModal.refSkuId,
            mps_pn: self.mpsShipTaaPnModal.mpsPn,
            ship_pn: self.mpsShipTaaPnModal.customShipPn,
            taa_pn: self.mpsShipTaaPnModal.taaPn,
          };
          //eventHub.$emit('loading', true);
          this.$axios
            .post(self.$root.baseUrl + '/nre/pn-for-nre/update/', requestData)
            .then(res => {
              let result = res.data;
              console.log("result.update_success::");
              console.log(result.update_success);
            })
            .finally(() => {
              self.getPage(null);
            });
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/customization-process/CustomizationNrePnPage.vue